// extracted by mini-css-extract-plugin
export var contact = "_Footer-module--contact--0a4be";
export var contacts = "_Footer-module--contacts--2cc07";
export var container = "_Footer-module--container--f383c";
export var footer = "_Footer-module--footer--e8895";
export var insta = "_Footer-module--insta--8a017";
export var logo = "_Footer-module--logo--a8f4b";